'use client';

import { createContext, useContext, ReactNode } from 'react';

interface GoogleReview {
	author_name: string;
	rating: number;
	text: string;
	relative_time_description?: string;
}

export interface GoogleReviewsData {
	rating: number;
	reviewCount: number;
	reviews: GoogleReview[];
	googleMapsUrl: string;
}

const DEFAULT_DATA: GoogleReviewsData = {
	rating: 4.9,
	reviewCount: 50,
	reviews: [],
	googleMapsUrl: 'https://www.google.com/maps/search/Breuer+Klimaattechniek',
};

const GoogleReviewsContext = createContext<GoogleReviewsData>(DEFAULT_DATA);

export function useGoogleReviews() {
	return useContext(GoogleReviewsContext);
}

export function GoogleReviewsProvider({
	children,
	initialData,
}: {
	children: ReactNode;
	initialData?: GoogleReviewsData;
}) {
	const data = initialData && initialData.reviews.length > 0 ? initialData : DEFAULT_DATA;

	return <GoogleReviewsContext.Provider value={data}>{children}</GoogleReviewsContext.Provider>;
}
